<template>
  <main class="page-content">

    <!-- <actions-svg-sprite /> -->

    <PageHeading
      :buttons="buttons"
      :action="tabChange"
      :isRadioStation="true"
    />

    <div class="container">
      <div class="section-title">
         <section-title
          :titleName="titleName"
          :titleCounter="favoriteChannelsRadio.length"
         >
         </section-title>
      </div>

      <cards-row v-for="(radiosInGroup, index) in groupRadios"
                 :key="index"
                 :cards="{items: radiosInGroup}"
                 :cardType="'Station'"
      />

    </div>

    <favorites-sidebar
      :favoritesVisible="favoritesVisible"
      :isRadioStation="true"
    />
  </main>
</template>

<script>
import PageHeading from 'components/PageHeading'
import SectionTitle from 'components/SectionTitle'
import FavoritesSidebar from 'components/FavoritesSidebar'
import CardsRow from 'components/cards/CardsRow'
import Card from 'components/cards/Card'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'RadioPlayer',
  components: {
    PageHeading,
    FavoritesSidebar,
    SectionTitle,
    CardsRow,
    Card
  },
  data: function () {
    return {
      buttons: [
        // {title: 'stb_guide_nowtv', name: 'nowtv', isActive: false},
        {title: 'stb_guide_tvchannels', name: 'guide', isActive: false},
        {title: 'stb_guide_radiostations', name: 'radio', isActive: true}
      ],
      titleCounter: 50,
      searchText: ''
    }
  },
  computed: {
    ...mapState({
      favoritesVisible: state => state.guide.favoritesVisible
    }),
    ...mapGetters([
      'favoriteChannelsRadio'
    ]),
    titleName: function () {
      return this.$t('stb_guide_radiostations')
    },
    groupRadios: function () {
      let itemsPerRow = 6
      let groupRadios = []
      let count = Math.ceil(this.favoriteChannelsRadio.length / itemsPerRow)
      for (let i = 0; i < count; i++) {
        groupRadios.push(this.favoriteChannelsRadio.slice(i * itemsPerRow, (i + 1) * itemsPerRow))
      }
      return groupRadios
    }
  },
  methods: {
    tabChange (name) {
      if (name === 'nowtv') {
        this.$router.push({ name: 'NowTv' })
      } else if (name === 'guide') {
        this.$router.push({ name: 'Guide' })
      } else if (name === 'radio') {
        this.$router.push({ name: 'RadioPlayer' })
      }
    }
  }
}
</script>

<style scoped lang="scss">
    // @import "_variables";

    // .page-content:before {
    //     content: '';
    //     width: 100%;
    //     height: 100%;
    //     background-image: linear-gradient(to bottom, #000000, #0c2b53 20%, #144585 51%, #0c2b53 80%, #000000);
    //     position: fixed;
    //     top: 0;
    //     left: 0;
    //     transform: translate3d(0,0,0);
    //     perspective: 1000px;
    //     backface-visibility: hidden;
    // }

    // .search-stations {
    //     float: right;
    //     width: 100%;
    //     max-width: 376px;
    //     margin-bottom: 20px;
    //     position: relative;

    //     input {
    //         width: 100%;
    //         line-height: 40px;
    //         height: 40px;
    //         padding-left: 11px;
    //         font-size: 16px;
    //         font-weight: 300;
    //         font-family: 'roboto', sans-serif;
    //         background-color: #07182d;
    //         color: #ebf3ff;
    //         border: 1px solid #0e3059;
    //         box-shadow: 0 0 10px 0 rgba(7, 24, 45, 0.3);

    //         &::-webkit-input-placeholder {
    //             font-style: italic;
    //             color: #ebf3ff;
    //             opacity: 0.7;
    //         }
    //         &::-moz-placeholder {
    //             font-style: italic;
    //             color: #ebf3ff;
    //             opacity: 0.7;
    //         }
    //         &:-ms-input-placeholder {
    //             font-style: italic;
    //             color: #ebf3ff;
    //             opacity: 0.7;
    //         }
    //         &:focus {
    //             &::-webkit-input-placeholder {
    //                 color: transparent;
    //             }
    //             &::-moz-input-placeholder {
    //                 color: transparent;
    //             }
    //             &:-ms-input-placeholder {
    //                 color: transparent;
    //             }
    //         }
    //     }
    //     i {
    //         position: absolute;
    //         top: 0;
    //         right: 0;
    //         padding-right: 13px;
    //         line-height: 40px;
    //         height: 40px;

    //         svg {
    //             display: inline-block;
    //             vertical-align: middle;
    //             width: 18px;
    //             height: 18px;
    //             fill: #ffffff;
    //         }
    //     }
    // }

    // @media only screen and (min-width: $breakpoint3) {
    //     /deep/ .section-title {
    //         margin-bottom: 20px;
    //             .col-grid-6 {
    //                 padding: 0 5px;
    //             }
    //     }
    // }

</style>



// WEBPACK FOOTER //
// src/containers/sections/RadioPlayer/_main.vue